import * as tslib_1 from "tslib";
import { EventEmitter, OnInit } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { FormComponentBase } from 'src/app/common/form-component-base';
import { Global } from 'src/app/common/global';
import { DataService } from 'src/app/services/api/data.service';
import { StaticDataService } from 'src/app/services/api/static-data.service';
import { SessionService } from 'src/app/services/session/session.service';
var TimeEntryTypeTranslationDialogComponent = /** @class */ (function (_super) {
    tslib_1.__extends(TimeEntryTypeTranslationDialogComponent, _super);
    function TimeEntryTypeTranslationDialogComponent(dataService, sessionService, staticDataService) {
        var _this = _super.call(this) || this;
        _this.dataService = dataService;
        _this.sessionService = sessionService;
        _this.staticDataService = staticDataService;
        _this.visibleValue = false;
        _this.visibleChange = new EventEmitter();
        _this.translateComplete = new EventEmitter();
        _this.gridData = [];
        _this.inheritClass = 'grid-inherit-cell';
        _this.childIsDirty = Array(1).fill(false);
        return _this;
    }
    Object.defineProperty(TimeEntryTypeTranslationDialogComponent.prototype, "visible", {
        get: function () {
            return this.visibleValue;
        },
        set: function (value) {
            if (this.visibleValue !== value) {
                this.visibleValue = value;
                this.visibleChange.emit(value);
                if (value) {
                    this.prepareTranslationData(this.timeEntryType);
                }
            }
        },
        enumerable: true,
        configurable: true
    });
    TimeEntryTypeTranslationDialogComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.staticDataService.languages.pipe(takeUntil(this.ngUnsubscribe)).subscribe(function (data) {
            _this.languages = data;
        });
    };
    Object.defineProperty(TimeEntryTypeTranslationDialogComponent.prototype, "IsReadOnly", {
        get: function () {
            return this.sessionService.role.IsReadOnly;
        },
        enumerable: true,
        configurable: true
    });
    TimeEntryTypeTranslationDialogComponent.prototype.onDialogAction = function (action) {
        if (action === 'Update') {
            this.updateTimeEntryTypeTranslation();
        }
    };
    TimeEntryTypeTranslationDialogComponent.prototype.onSaveChange = function (value) {
        this.childIsDirty[0] = true;
    };
    TimeEntryTypeTranslationDialogComponent.prototype.prepareTranslationData = function (timeEntry) {
        var _this = this;
        this.gridData = [];
        if (!timeEntry) {
            return;
        }
        this.dataService.TimeEntryTypes_GetTranslations(timeEntry.Id).subscribe(function (data) {
            _this.gridData = data;
        });
    };
    TimeEntryTypeTranslationDialogComponent.prototype.getFieldTranslation = function (fieldName) {
        var translationText;
        if (this.timeEntryType &&
            this.timeEntryType.TimeEntryTypeTranslations &&
            this.timeEntryType.TimeEntryTypeTranslations.length > 0) {
            var translation = this.timeEntryType.TimeEntryTypeTranslations.find(function (t) { return t.LanguageId === Global.SESSION.SignOnToken.LanguageId; });
            translationText = translation ? translation[fieldName] : undefined;
        }
        return translationText;
    };
    TimeEntryTypeTranslationDialogComponent.prototype.getBaseTranslation = function (fieldName, languageId) {
        if (!this.timeEntryType || !this.timeEntryType.BaseTimeEntryType) {
            return undefined;
        }
        var translationText;
        if (this.timeEntryType.BaseTimeEntryType.TimeEntryTypeTranslations &&
            this.timeEntryType.BaseTimeEntryType.TimeEntryTypeTranslations.length > 0) {
            var translation = this.timeEntryType.BaseTimeEntryType.TimeEntryTypeTranslations.find(function (t) { return t.LanguageId === languageId; });
            translationText = translation ? translation[fieldName] : undefined;
        }
        return translationText ? translationText : this.timeEntryType.BaseTimeEntryType[fieldName];
    };
    TimeEntryTypeTranslationDialogComponent.prototype.updateTimeEntryTypeTranslation = function () {
        var _this = this;
        if (!this.gridData) {
            return;
        }
        this.dataService.TimeEntryTypes_SetTranslations(this.gridData).subscribe(function (data) {
            _this.translateComplete.emit(data);
            _this.gridData = data;
            _this.visible = false;
        });
    };
    return TimeEntryTypeTranslationDialogComponent;
}(FormComponentBase));
export { TimeEntryTypeTranslationDialogComponent };
